export const formValidator = {
  methods: {
    isValid (form) {
      if (!form.checkValidity()) {
        const fields = form.querySelectorAll('.form-control');

        for (const field of fields) {
          const refID = field.getAttribute('id');

          if (this.$refs[refID]) {
            this.$refs[refID].validate();
          }
        }

        return false;
      };
      return true;
    }
  }
};
